/* eslint-disable max-lines-per-function */
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { StationArbeitsbereichCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationArbeitsbereichCard';
import { StationMitarbeiterCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/mobile/components/StationMitarbeiterCard';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';

export function Kalender({
  view,
}: {
  view: 'mitarbeiter' | 'arbeitsbereiche';
}) {
  const {
    store: {
      data: { rotationsplaene, rotationsplaeneByArbeitsbereiche },
      ui: {
        kalender: { currentStartOfWeek },
      },
    },
  } = useRotationsplanFeatureContext();

  return (
    <div className="flex flex-col gap-4">
      {view === 'arbeitsbereiche'
        ? rotationsplaeneByArbeitsbereiche.map((arbeitsbereich) =>
            arbeitsbereich.stationen
              ?.filter(
                (station) =>
                  dayjs(station.von).isoWeek() <=
                    currentStartOfWeek.isoWeek() &&
                  dayjs(station.bis).isoWeek() >= currentStartOfWeek.isoWeek(),
              )
              .map((station) => {
                return (
                  <StationArbeitsbereichCard
                    key={station.id}
                    arbeitsbereich={arbeitsbereich}
                    station={station}
                  />
                );
              }),
          )
        : rotationsplaene.map((rotationsplan) =>
            rotationsplan
              .getAllStationen()
              ?.filter(
                (station) =>
                  dayjs(station.von).isoWeek() <=
                    currentStartOfWeek.isoWeek() &&
                  dayjs(station.bis).isoWeek() >= currentStartOfWeek.isoWeek(),
              )
              .filter((station) => station instanceof ArbeitsbereichStation)
              .map((station) => {
                return (
                  <StationMitarbeiterCard
                    key={station.id}
                    mitarbeiter={rotationsplan.mitarbeiter}
                    station={station}
                    lehrjahr={rotationsplan.getCurrentLehrjahr()}
                    beruf={rotationsplan.beruf}
                  />
                );
              }),
          )}
    </div>
  );
}
